<template lang="pug">
  campaign-action-center(:campaignId="id" :actionId="actionId")
</template>

<script>
import CampaignActionCenter from './components/CampaignActionCenter';

export default {
  components: {
    CampaignActionCenter,
  },
  props: {
    id: String, // The Campaign id
    actionId: String, // The Action ID
  },
};
</script>
